import {Component, ViewEncapsulation} from '@angular/core';
import {first, Observable} from "rxjs";
import {NotificationService} from "../../../../services/notification.service";
import {Router} from "@angular/router";
import {CountryService} from "../../../../services/country.service";
import {EnergySourcesDataSource} from "./energy-sources.data-source";
import {EnergySourcesService} from "../../../../services/energy-source.service";
import {TypeTranslatePipe} from "../../../../pipes/typetranslate.pipe";
@Component({
  selector: 'app-energy-sources',
  templateUrl: './energy-sources.component.html',
  styleUrls: ['./energy-sources.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EnergySourcesComponent {
  // Columns
  displayedColumns = ['name', 'co2Factor', 'calorificValue', 'unit', 'lastModifiedBy', 'lastModifiedDate']

  dataSource: EnergySourcesDataSource
  loading$: Observable<boolean>

  constructor(
    private country: CountryService,
    private router: Router,
    private energySourcesService: EnergySourcesService,
    private notification: NotificationService) {

    this.dataSource = new EnergySourcesDataSource(energySourcesService)
    this.loading$ = this.dataSource.loading$
  }

  submit() {
    const updates = this.dataSource.getChanges()

    if (updates.length === 0) {
      this.notification.info("Nothing to submit")
      return;
    }

    this.energySourcesService.putEnergySources(updates)
      .pipe(first())
      .subscribe((updatedSources) => {
        this.dataSource.applyUpdates(updatedSources)
        this.notification.success(`Submitted ${updatedSources.length} energy sources`)
      })
  }
}
